import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'
import { options } from 'marked'

const { PlusTradeWeb, PlusCrmWeb, PlusFmsWeb, Esign, BpmWeb } = UrlConfig

// 订单列表
export const getOrderList = async options => {
  return request(PlusTradeWeb.GetOrderList, {
    method: METHODS.POST,
    ...options,
  })
}
// 订单详情
export const getQuoteGoodsList = async options => {
  return request(PlusTradeWeb.GetQuoteGoodsList, {
    method: METHODS.POST,
    ...options,
  })
}
// 订单列表 删除接口
export const orderOpreation = async options => {
  return request(PlusTradeWeb.OrderOpreation, {
    method: METHODS.DELETE,
    ...options,
  })
}
// 订单详情 报价列表信息

export const getQuoteBudgetList = async options => {
  return request(PlusTradeWeb.GetquoteBudgetList, {
    method: METHODS.POST,
    ...options,
  })
}
// 订单详情 报价图纸查询

export const getSelectBudgetDrawing = async params => {
  return request(PlusTradeWeb.GetSelectBudgetDrawing, {
    method: METHODS.GET,
    params,
  })
}

// 订单详情 报价图纸保存

export const saveOrUpdateBudgetDrawing = async options => {
  return request(PlusTradeWeb.SaveOrUpdateBudgetDrawing, {
    method: METHODS.POST,
    ...options,
  })
}
// 订单详情 合同列表
export const getElecConctList = async options => {
  return request(PlusTradeWeb.GetElecConctList, {
    method: METHODS.POST,
    ...options,
  })
}

// 订单号查合同列表
export const getElecConctSupport = async (data: any) => {
  return await request(UrlConfig.PlusTradeWeb.GetElecConctSupport, {
    method: METHODS.POST,
    ...data,
  })
}
// 查询订单服务人员
export const orderServicePersonnel = async (orderId: string) => {
  return await request(UrlConfig.PlusTradeWeb.OrderServicePersonnel + orderId, {
    method: METHODS.GET,
  })
}
// 变更订单服务人员
export const orderServicePersonnelUpdate = async (orderId: string, data) => {
  return await request(UrlConfig.PlusTradeWeb.OrderServicePersonnelUpdate + orderId, {
    method: METHODS.POST,
    data,
  })
}

// 订单详情 合同列表 删除合同
export const delElecConct = id => {
  return request(`${PlusTradeWeb.DelElecConct}?elecId=${id}`, {
    method: METHODS.POST,
  })
}

// 获取服务人员数据
export const getOrderRelativesList = async options => {
  return request(PlusTradeWeb.GetOrderRelativesList, {
    method: METHODS.POST,
    ...options,
  })
}
// 获取服务人员数据-各下拉设计师选项数据
export const getTrackPlanRelativesList = async (options): Promise<any[]> => {
  return request(PlusCrmWeb.GetTrackPlanRelativesList, {
    method: METHODS.POST,
    ...options,
  })
}
// 服务人员-修改
export const orderRelativesUpdate = async options => {
  return request(PlusTradeWeb.OrderRelativesUpdate, {
    method: METHODS.POST,
    ...options,
  })
}

// 选材查询分类树
export const quoteBudgetItemTree = async options => {
  return request(PlusTradeWeb.QuoteBudgetItemTree, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询项目/子项树
export const queryProjectTree = async options => {
  return request(PlusTradeWeb.QueryProjectTree, {
    method: METHODS.POST,
    ...options,
  })
}
// 报价明细查询
export const getListBudgetDtl = async options => {
  return request(PlusTradeWeb.ListBudgetDtl + '/' + options.id, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询条件-报价通项
export const getSelectGeneralTerm = async options => {
  return request(PlusTradeWeb.SelectGeneralTerm, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询条件-品牌查询---通项
export const selectBrandByGeneralTerm = async options => {
  return request(PlusTradeWeb.SelectBrandByGeneralTerm, {
    method: METHODS.POST,
    ...options,
  })
}
// 通项列表查询---通项
export const generalSearch = async options => {
  return request(PlusTradeWeb.GeneralSearch, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-项目选材搜索
export const projectSearch = async options => {
  return request(PlusTradeWeb.ProjectSearch, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-项目选材搜索分页
export const projectSearchPage = async options => {
  return request(
    PlusTradeWeb.ProjectSearchPage +
      `?pageId=${options?.data?.current}&pageSize=${options?.data?.pageSize}`,
    {
      method: METHODS.POST,
      ...options,
    }
  )
}
// 搜索-通项选材搜索分页
export const generalSearchPage = async options => {
  return request(
    PlusTradeWeb.GeneralSearchPage +
      `?pageId=${options?.data?.current}&pageSize=${options?.data?.pageSize}`,
    {
      method: METHODS.POST,
      ...options,
    }
  )
}
// 搜索-升降级选材搜索分页
export const upDownSearchPage = async options => {
  return request(
    PlusTradeWeb.UpDownSearchPage +
      `?pageId=${options?.data?.current}&pageSize=${options?.data?.pageSize}`,
    {
      method: METHODS.POST,
      ...options,
    }
  )
}
// 搜索-增项选材搜索分页
export const additionSearchPage = async options => {
  return request(
    PlusTradeWeb.AdditionSearchPage +
      `?pageId=${options?.data?.current}&pageSize=${options?.data?.pageSize}`,
    {
      method: METHODS.POST,
      ...options,
    }
  )
}

// 订单详情 交易流水列表
export const getTradingStatementList = async options => {
  return request(PlusFmsWeb.GetTradingStatementList, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询空间
export const DetailHouseInfoList = async options => {
  return request(PlusTradeWeb.QueryItemOptional, {
    method: METHODS.GET,
    ...options,
  })
}
// 查询条件-保存选材---通项
export const saveBudgetDtl = async options => {
  return request(PlusTradeWeb.SaveBudgetDtl, {
    method: METHODS.POST,
    ...options,
  })
}

// 新增报价 - 根据goodsId查询关联规格参数
export const quoteBudgetSelectBudgetInitArg = async options => {
  return request(PlusTradeWeb.QuoteBudgetSelectBudgetInitArg, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 根据所选报价类型查询关联费用项参数
export const quoteBudgetSelectCreatorEntryPrice = async options => {
  return request(PlusTradeWeb.QuoteBudgetSelectCreatorEntryPrice, {
    method: METHODS.POST,
    ...options,
  })
}
// 编辑报价
export const updateQuoteBudgetId = async data => {
  return request(PlusTradeWeb.UpdateQuoteBudgetId, {
    method: METHODS.POST,
    data,
  })
}
// 查询条件-产品分类列表
export const listProductCategory = async options => {
  return request(PlusTradeWeb.ListProductCategory, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询条件-品牌列表
export const listBrand = async options => {
  return request(PlusTradeWeb.ListBrand, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-增项选材搜索
export const additionSearch = async options => {
  return request(PlusTradeWeb.AdditionSearch, {
    method: METHODS.POST,
    ...options,
  })
}
// 选材过程-表达式计算
export const calcExpress = async options => {
  return request(PlusTradeWeb.CalcExpress, {
    method: METHODS.POST,
    ...options,
  })
}
// 选材过程-显示sku对应的spu的规格
export const listProductSkuRelationSpuFormat = async options => {
  return request(PlusTradeWeb.ListProductSkuRelationSpuFormat, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-减项选材搜索
export const subtractSearch = async options => {
  return request(PlusTradeWeb.SubtractSearch, {
    method: METHODS.POST,
    ...options,
  })
}

// 查询枚举
export const getTradeEnums = async (path): Promise<any[]> => {
  return request(PlusTradeWeb.GetEnums + path, { method: METHODS.GET }).then(
    (res: any) => res || []
  )
}

export const cancelOrder = async options => {
  return request(PlusTradeWeb.CancelOrder, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 空间户型初始化
export const quoteBudgetInitQuoteBudgetItem = async options => {
  return request(PlusTradeWeb.QuoteBudgetInitQuoteBudgetItem, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 输入型参数初始化
export const matchProductSku = async options => {
  return request(PlusTradeWeb.MatchProductSku, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 保存
export const addQuoteBudget = async options => {
  return request(PlusTradeWeb.AddQuoteBudget, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 保存
export const queryHouseInfo = async options => {
  return request(PlusTradeWeb.QueryHouseInfo, {
    method: METHODS.POST,
    ...options,
  })
}
// 新增报价 - 保存
export const saveHouseInfo = async options => {
  return request(PlusTradeWeb.SaveHouseInfo, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询价格分类树
export const quoteBudgetPriceQueryTree = async options => {
  return request(PlusTradeWeb.QuoteBudgetPriceQueryTree, {
    method: METHODS.POST,
    ...options,
  })
}
// 查询价格
export const getCalcQuoteBudgetPrice = async options => {
  return request(PlusTradeWeb.CalcQuoteBudgetPrice, {
    method: METHODS.POST,
    ...options,
  })
}
// 刷新价格
export const refreshQuoteBudgetPrice = async options => {
  return request(PlusTradeWeb.RefreshQuoteBudgetPrice, {
    method: METHODS.POST,
    ...options,
  })
}
//选材- 获取订单信息
export const quoteBudgetSelectQuoteBudgetInfo = async options => {
  return request(PlusTradeWeb.QuoteBudgetSelectQuoteBudgetInfo, {
    method: METHODS.GET,
    ...options,
  })
}
//选材过程-根据spu以及规格对应的sku
export const sureProductSkuBySpuAndFormatArgs = async options => {
  return request(PlusTradeWeb.SureProductSkuBySpuAndFormatArgs, {
    method: METHODS.POST,
    ...options,
  })
}

// 根据Id删除数据
export const deleteQuoteBudgetDtl = async options => {
  return await request(PlusTradeWeb.DeleteQuoteBudgetDtl + options.params.id, {
    method: METHODS.DELETE,
  })
}
// 根据Id删除数据
export const deleteByIdAndBudgetId = async options => {
  return await request(
    PlusTradeWeb.DeleteByIdAndBudgetId + options.params.budgetId + '/' + options.params.id,
    {
      method: METHODS.DELETE,
    }
  )
}
// 获取支付id
export const addPaymentApplyForOrder = async options => {
  return await request(UrlConfig.PlusFmsWeb.AddPaymentApplyForOrder, {
    method: METHODS.POST,
    ...options,
  })
}
// 根据Id删除数据
export const deleteQuoteBudget = async options => {
  return await request(PlusTradeWeb.DeleteQuoteBudget + options.params.id, {
    method: METHODS.DELETE,
  })
}
// 获取支付id
export const updateDynaOptions = async options => {
  return await request(PlusTradeWeb.UpdateDynaOptions, {
    method: METHODS.POST,
    ...options,
  })
}
export const updateBudgetField = async options => {
  return await request(PlusTradeWeb.UpdateBudgetField, {
    method: METHODS.POST,
    ...options,
  })
}

export const chooseCheck = async options => {
  return await request(PlusTradeWeb.ChooseCheck, {
    method: METHODS.GET,
    ...options,
  })
}
export const subSearchList = async options => {
  return await request(PlusTradeWeb.SubSearchList, {
    method: METHODS.POST,
    ...options,
  })
}

// 搜索栏 分公司下拉
export function getBranchComponyList() {
  return request(UrlConfig.Caas.GetCompanyList, {
    method: METHODS.POST,
    data: {},
  })
}

// 外部数据校验
export const verifyOuterData = async options => {
  return await request(UrlConfig.PmsWeb.VerifyOuterData + '/' + options.params.id, {
    method: METHODS.POST,
    ...options,
  })
}

// 发起设计方案审核
export const initiateSchemeReview = async options => {
  return await request(UrlConfig.PlusTradeWeb.InitiateSchemeReview, {
    method: METHODS.POST,
    ...options,
  })
}

// 提交设计方案审核
export const submitSchemeReview = async options => {
  return await request(UrlConfig.PlusTradeWeb.SubmitSchemeReview, {
    method: METHODS.POST,
    ...options,
  })
}

// 申请开工
export const startWork = async options => {
  return await request(UrlConfig.PmsWeb.StartWork, {
    method: METHODS.POST,
    ...options,
  })
}

// 零售退款
export function startRefundRetail(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundRetail, {
    method: METHODS.POST,
    data,
  })
}
// 获取活动信息查询
export const queryActivity = async options => {
  return await request(PlusTradeWeb.QueryActivity, {
    method: METHODS.GET,
    ...options,
  })
}

// 获取活动信息 物料查询分页
export const queryActivityProduct = async options => {
  return await request(PlusTradeWeb.QueryActivityProduct, {
    method: METHODS.POST,
    ...options,
  })
}

// 退单非零售
export function startRefundNonRetail(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundNonRetail, {
    method: METHODS.POST,
    data,
  })
}
// 退定金
export function startRefundDeposit(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundDeposit, {
    method: METHODS.POST,
    data,
  })
}
// 退设计费
export function startRefundDesign(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundDesign, {
    method: METHODS.POST,
    data,
  })
}

// 查询可退金额
export function findCanRefundTrans(data: any) {
  return request(UrlConfig.PlusFmsWeb.FindCanRefundTrans, {
    method: METHODS.POST,
    data,
  })
}

// 退余额
export function startRefundBalance(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundBalance, {
    method: METHODS.POST,
    data,
  })
}

// 订单详情
export const orderDetail = (id: any) => {
  return request(PlusTradeWeb.OrderOpreation + `/${id}`, {
    method: METHODS.GET,
  })
}

// 退单重签
export function startRefundReSign(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundReSign, {
    method: METHODS.POST,
    data,
  })
}
// 退单重签可选订单
export function startRefundReSignGetOrders(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartRefundReSignGetOrders, {
    method: METHODS.POST,
    data,
  })
}
// 异常退单
export function startAbnormalReturn(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartAbnormalReturn, {
    method: METHODS.POST,
    data,
  })
}

// 超标优惠
export function startMerchOverflow(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartMerchOverflow, {
    method: METHODS.POST,
    data,
  })
}

// 发起整装图纸审核申请
export function startCompleteDrawing(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartCompleteDrawing, {
    method: METHODS.POST,
    data,
  })
}
// 快速创建订单
export function quickPlaceOrder(data: any) {
  return request(UrlConfig.PlusTradeWeb.QuickPlaceOrder, {
    method: METHODS.POST,
    data,
  })
}

// 整装图纸再次上传
export function reUploadDrawer(data: any) {
  return request(UrlConfig.PlusTradeWeb.ReUploadDrawer, {
    method: METHODS.POST,
    data,
  })
}

// 修改物料选中状态
export const updateChooseFlag = async options => {
  return await request(PlusTradeWeb.UpdateChooseFlag, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-升降级搜索
export const upDownSearch = async options => {
  return request(PlusTradeWeb.UpDownSearch, {
    method: METHODS.POST,
    ...options,
  })
}
// 缺断货可选材类型
export const getDtlRefType = async options => {
  return request(PlusTradeWeb.GetDtlRefType, {
    method: METHODS.GET,
    ...options,
  })
}
// 整装图纸预览
export function previewPackagedDrawingPdf(params: any) {
  return request(UrlConfig.PlusTradeWeb.PreviewPackagedDrawingPdf, {
    method: METHODS.GET,
    params,
  })
}

// 根据orderId查询供应商
export function findSuppliersByOrderId(params: any) {
  return request(UrlConfig.PlusTradeWeb.FindSuppliersByOrderId, {
    method: METHODS.GET,
    params,
  })
}

// 查详情
export function quoteGoodsDetail(id: any) {
  return request(UrlConfig.PlusTradeWeb.QuoteGoodsDetail + `/${id}`, {
    method: METHODS.GET,
  })
}
// 订单详情 定制图纸保存

export const saveOrUpdateCustomDrawing = async options => {
  return request(PlusTradeWeb.SaveOrUpdateCustomDrawing, {
    method: METHODS.POST,
    ...options,
  })
}

// 订单详情 定制图纸查询

export const selectCustomDrawing = async params => {
  return request(PlusTradeWeb.SelectCustomDrawing, {
    method: METHODS.GET,
    params,
  })
}
export function updatePackDtl(data: any) {
  return request(UrlConfig.PlusTradeWeb.updatePackDtl, {
    method: METHODS.POST,
    ...data,
  })
}

// 订单详情 定制图纸审核

export const startCustomDrawing = async data => {
  return request(PlusTradeWeb.StartCustomDrawing, {
    method: METHODS.POST,
    data,
  })
}

// 订单详情 定制图纸详情

export const selectCustomDrawingDetail = async params => {
  return request(PlusTradeWeb.SelectCustomDrawingDetail, {
    method: METHODS.GET,
    params,
  })
}

// 订单详情 定制图纸撤回

export const deleteCustomDrawingProcessInstance = async params => {
  return request(PlusTradeWeb.DeleteCustomDrawingProcessInstance, {
    method: METHODS.GET,
    params,
  })
}

// 订单按钮
export const orderGetButton = async params => {
  return request(PlusTradeWeb.OrderGetButton, {
    method: METHODS.GET,
    params,
  })
}
// 直接付款退款信息
export const getByFlowKeyAndOrderld = async options => {
  return request(PlusTradeWeb.GetByFlowKeyAndOrderld, {
    method: METHODS.GET,
    ...options,
  })
}

// 订单替换商品
export function orderReplaceGoods(data: any) {
  return request(UrlConfig.PlusTradeWeb.OrderReplaceGoods, {
    method: METHODS.POST,
    data,
  })
}
// 查询物料动态属性
export const selectMaterialDynaOptions = async options => {
  return request(PlusTradeWeb.SelectMaterialDynaOptions, {
    method: METHODS.GET,
    ...options,
  })
}
// 查询物料动态属性
export const updateMaterialDynaOptions = async options => {
  return request(PlusTradeWeb.UpdateMaterialDynaOptions, {
    method: METHODS.POST,
    ...options,
  })
}
// 发起修改合同地址流程
export const startBpmFlow = async options => {
  return request(PlusTradeWeb.StartBpmFlow, {
    method: METHODS.POST,
    ...options,
  })
}

// 订单替换商品
export function checkTemplateUpdate(options: any) {
  return request(UrlConfig.PlusTradeWeb.CheckTemplateUpdate, {
    method: METHODS.POST,
    ...options,
  })
}

// 订单替换商品
export function changeBaseInfo(options: any) {
  return request(UrlConfig.PlusTradeWeb.ChangeBaseInfo, {
    method: METHODS.POST,
    ...options,
  })
}
//根据报价类型获取对应的特殊代码集合
export function budgetForSpecialCode(options: any) {
  return request(UrlConfig.PlusTradeWeb.BudgetForSpecialCode, {
    method: METHODS.GET,
    ...options,
  })
}

export function budgetForAllSpecialCode(options: any) {
  return request(UrlConfig.PlusTradeWeb.BudgetForAllSpecialCode, {
    method: METHODS.GET,
    ...options,
  })
}

//回显空间规格
export const selectMainSpaceSpec = async data => {
  return request(PlusTradeWeb.SelectMainSpaceSpec, {
    method: METHODS.POST,
    data,
  })
}

// 提交开工页面-详情
export function submitPageDetail(orderId: any) {
  return request(UrlConfig.PmsWeb.submitPageDetail + `/${orderId}`, {
    method: METHODS.GET,
  })
}
// 获取JDPIn
export const getJdPin = async id => {
  return request(PlusTradeWeb.GetJdPin + '?trackId=' + id, {
    method: METHODS.GET,
  })
}
//回显空间规格
export const bindJdOrder = async data => {
  return request(PlusTradeWeb.BindJdOrder, {
    method: METHODS.POST,
    data,
  })
}

// 资金池-详情
export function getCapitalPool(quoteId: any) {
  return request(PlusTradeWeb.GetCapitalPool, {
    method: METHODS.GET,
    params: {
      quoteId,
    },
  })
}
// 配置清单详情
export function getConfigurations(budgetId: any) {
  return request(PlusTradeWeb.GetConfigurations + '/' + budgetId, {
    method: METHODS.GET,
  })
}
// 资金池详情报价-产品列表
export const listBudgetDtlSimple = async options => {
  return request(PlusTradeWeb.ListBudgetDtlSimple + '/' + options.id, {
    method: METHODS.POST,
    ...options,
  })
}

// 选材类型
export const selectQuoteBudgetDtlRefTypeEnum = async params => {
  return request(PlusTradeWeb.SelectQuoteBudgetDtlRefTypeEnum, {
    method: METHODS.GET,
    params,
  })
}
// 项目选材-项目列表
export const getListBudgetItem = async data => {
  return request(PlusTradeWeb.GetListBudgetItem, {
    method: METHODS.POST,
    data,
  })
}
// 选材校验
export const checkGeneralStandard = async data => {
  return request(PlusTradeWeb.CheckGeneralStandard, {
    method: METHODS.POST,
    data,
  })
}
// 整装图纸-查询签字链接
export const getSignLinkUrl = async data => {
  return request(Esign.EsignGetSignLinkUrl, {
    method: METHODS.POST,
    data,
  })
}
/**
 * 强制撤回（合同）
 * @param data
 * @returns
 */
export const forcedWithdrawal = (data: { elecId: string }) => {
  return request(`${Esign.ForcedWithdrawal}?elecId=${data.elecId}`, {
    method: METHODS.POST,
  })
}
// 整装图纸-查询签字链接
export const merchOverflowList = async data => {
  return request(PlusTradeWeb.MerchOverflowList, {
    method: METHODS.POST,
    data,
  })
}

// 获取减项选材列表
export function getSubSearch(options: any) {
  return request(UrlConfig.PlusTradeWeb.getSubSearch, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-增项选材搜索
export const additionSearchForGeneral = async options => {
  return request(PlusTradeWeb.AdditionSearchForGeneral, {
    method: METHODS.POST,
    ...options,
  })
}
// 搜索-预置产品增项选材搜索
export const additionSearchForSpecialAdd = async options => {
  return request(PlusTradeWeb.AdditionSearchForSpecialAdd, {
    method: METHODS.POST,
    ...options,
  })
}
// 发起标准工期待定/锁定申请
export function startDurationFlow(data: any) {
  return request(UrlConfig.PlusTradeWeb.StartDurationFlow, {
    method: METHODS.POST,
    data,
  })
}
// 差异化清单
export const dtlDifferenceList = async options => {
  return request(PlusTradeWeb.DtlDifferenceList, {
    method: METHODS.POST,
    ...options,
  })
}
// 发起标准工期待定/锁定申请
export function orderStandInStartWorkFlow(orderId: any) {
  return request(UrlConfig.PlusTradeWeb.OrderStandInStartWorkFlow + `?orderId=${orderId}`, {
    method: METHODS.GET,
  })
}
// 通知客户-校验[ADD]
export function checkForNotifyCustomer(data: any) {
  return request(UrlConfig.PlusTradeWeb.CheckForNotifyCustomer, {
    method: METHODS.POST,
    data,
  })
}
// 通知客户-发送
export function notifyCustomer(data: any) {
  return request(UrlConfig.PlusTradeWeb.NotifyCustomer, {
    method: METHODS.POST,
    data,
  })
}

//查询预计开工时间[ADD]-检查是否发起合同true是可以发起，false不可以发起
export function checkExpectProjectStartDate(params: any) {
  return request(UrlConfig.PlusTradeWeb.CheckExpectProjectStartDate, {
    method: METHODS.GET,
    params,
  })
}

//获取日历详情
export function getScpPlan(data: any) {
  return request(UrlConfig.PmsWeb.GetScpPlan, {
    method: METHODS.POST,
    data,
  })
}

// 查询图审配置
export function searchDiagramReviewConfig(options: any) {
  return request(UrlConfig.PlusTradeWeb.SearchDiagramReviewConfig, {
    method: METHODS.POST,
    ...options,
  })
}

// 新增图审配置
export function addDiagramReviewConfig(data: any) {
  return request(UrlConfig.PlusTradeWeb.AddDiagramReviewConfig, {
    method: METHODS.POST,
    data,
  })
}

//获取开工资源占用详情
export function getOrderProjectPlan(orderId: any) {
  return request(`${UrlConfig.PlusTradeWeb.GetOrderProjectPlan}/${orderId}`, {
    method: METHODS.GET,
  })
}

//预计完工日期
export function calculateEndDate(data: any) {
  return request(UrlConfig.PmsWeb.CalculateEndDate, {
    method: METHODS.POST,
    data,
  })
}

// 编辑图审配置
export function editDiagramReviewConfig(data: any) {
  return request(UrlConfig.PlusTradeWeb.EditDiagramReviewConfig, {
    method: METHODS.POST,
    data,
  })
}

//保存占用开工资源
export function submitOrderProjectPlan(data: any) {
  return request(UrlConfig.PlusTradeWeb.SubmitOrderProjectPlan, {
    method: METHODS.POST,
    data,
  })
}

// 删除图审配置
export const deleteDiagramReviewConfig = async id => {
  return await request(PlusTradeWeb.DeleteDiagramReviewConfig + id, {
    method: METHODS.DELETE,
  })
}

export function checkQuoteElecConct(data = {}) {
  return request(`${UrlConfig.PlusTradeWeb.CheckQuoteElecConct}`, {
    method: METHODS.POST,
    data: data?.quoteBudgetId,
  })
}
export function quoteBudgetItemType(data: any) {
  return request(UrlConfig.PlusTradeWeb.QuoteBudgetItemType, {
    method: METHODS.POST,
    data,
  })
}
export function getAllSapce(id: any) {
  return request(UrlConfig.PlusTradeWeb.GetAllSapce + '?quoteBudgetId=' + id, {
    method: METHODS.POST,
  })
}
export function batchUpdateSort(data: any) {
  return request(UrlConfig.PlusTradeWeb.BatchUpdateSort, {
    method: METHODS.POST,
    data,
  })
}
export function updateQuoteBudgetDtl(data: any) {
  return request(UrlConfig.PlusTradeWeb.UpdateQuoteBudgetDtl, {
    method: METHODS.POST,
    data,
  })
}
export function batchUpdateOrderSeq(data: any) {
  return request(UrlConfig.PlusTradeWeb.BatchUpdateOrderSeq, {
    method: METHODS.POST,
    data,
  })
}
export function queryChooseButton(data: any) {
  return request(UrlConfig.PlusTradeWeb.QueryChooseButton, {
    method: METHODS.POST,
    data,
  })
}

//预计工期
export function findTemplateAndSubs(data: any) {
  return request(UrlConfig.PlusTradeWeb.FindTemplateAndSubs, {
    method: METHODS.POST,
    data,
  })
}

// 根据订单id查楼盘
export const findBuildingInfoForOrderResponseByRequest = async data => {
  return request(PlusTradeWeb.findBuildingInfoForOrderResponseByRequest, {
    method: METHODS.POST,
    data,
  })
}

//查交底单按钮
export function getButtonNew(params: any) {
  return request(UrlConfig.PlusTradeWeb.GetButtonNew, {
    method: METHODS.GET,
    params,
  })
}

//占用开工校验接口
export function checkDesignerSetStartWorkDate(options: any) {
  return request(UrlConfig.PlusTradeWeb.CheckDesignerSetStartWorkDate, {
    method: METHODS.POST,
    ...options,
  })
}
// 图审审核状态枚举
export const getQuotationFlowEnum = async () => {
  return request(PlusTradeWeb.GetQuotationFlowEnum, {
    method: METHODS.GET,
  })
}

// 图审审核列表
export const quotationProposalPage = async (options) => {
  return request(PlusTradeWeb.QuotationProposalPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 查找优惠券使用信息
export const selectRefActivityOrder = async options => {
  return request(PlusTradeWeb.SelectRefActivityOrder, {
    method: METHODS.POST,
    ...options,
  })
}

// 流程数据
export const getDetailByProcInstId = async (options) => {
  return request(BpmWeb.GetDetailByProcInstId, {
    method: METHODS.POST,
    ...options,
  })
}

// 配置清单详情
export function listBudgetDtlByDiff(data: any) {
  return request(UrlConfig.PlusTradeWeb.ListBudgetDtlByDiff + '?budgetId=' + data?.budgetId + '&refItemId=' + data?.refItemId + '&quotationFlowId=' + data?.quotationFlowId, {
    method: METHODS.GET,
  })
}

// 查询物料动态属性
export const subSearchListProcess = async data => {
  return request(UrlConfig.PlusTradeWeb.SubSearchListProcess + '?budgetId=' + data?.budgetId + '&refItemId=' + data?.refItemId + '&quotationFlowId=' + data?.quotationFlowId, {
    method: METHODS.GET,
  })
}

export function selectBudgetDrawingByDiff(data = {}) {
  return request(`${UrlConfig.PlusTradeWeb.SelectBudgetDrawingByDiff}?budgetId=${data?.quoteBudgetId}&quotationFlowId=${data?.quotationFlowId}`, {
    method: METHODS.GET,
  })
}

/**
 * 审批
 * @param options params{id,procInstId}
 */
export const flowDetailFinish = (options?: any) =>
  request(UrlConfig.BpmWeb.GetFlowDetailFinish, {
    method: METHODS.POST,
    ...options,
  })

/**
 * 流程转办
 * @param options 
 */
export const getFlowTranster = (data) =>
  request(UrlConfig.BpmWeb.GetFlowDetailTransfer, {
    method: METHODS.POST,
    data,
  })

/**
 * 流程转办用户
 * @param options
 */ 
export const getUserIdentityFn = (data:any)=>{
  return request(UrlConfig.Caas.GetUserIdentityPage+`?pageId=1&pageSize=100`, {
    method: METHODS.POST,
    data,
  })
} 

// 审核记录查询
export const getAuditRecord = async (options) => {
  return request(UrlConfig.PlusTradeWeb.GetAuditRecord, {
    method: METHODS.POST,
    ...options,
  })
}

// 审核批复详情查询
export const queryReviewApproval = async (options) => {
  return request(UrlConfig.PlusTradeWeb.QueryReviewApproval, {
    method: METHODS.POST,
    ...options,
  })
}

// 审核批复保存
export const saveReviewApproval = async (data) => {
  return request(UrlConfig.PlusTradeWeb.SaveReviewApproval, {
    method: METHODS.POST,
    data,
  })
}

// 校验合同发起是否有优惠券
export const checkWarningBeforeContract = async data => {
  return request(PlusTradeWeb.CheckWarningBeforeContract, {
    method: METHODS.POST,
    data,
  })
}

// 排序
export const batchUpdateQuoteSort = async data => {
  return request(PlusTradeWeb.BatchUpdateQuoteSort, {
    method: METHODS.POST,
    data,
  })
}

// 核销状态枚举
export const getVerifyStateEnum = async () => {
  return request(PlusTradeWeb.GetVerifyStateEnum, {
    method: METHODS.GET,
  })
}